import { render, staticRenderFns } from "./FooterColor.vue?vue&type=template&id=368070f6"
import script from "./FooterColor.vue?vue&type=script&lang=js"
export * from "./FooterColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports